import { b, a } from './chunk-FUQLNXR2.mjs';
import { jsx } from 'react/jsx-runtime';

var n=t=>jsx("svg",b(a({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 512 512",fill:"currentColor"},t),{children:jsx("path",{d:"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"})})),p=n;

export { p as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-HID5N56K.mjs.map